<script>
	// imports
	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";
	import { isValid } from "../../validation";
	import { registerPageComplete } from "../../tealium";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import MedicalProviders from "../../components/MedicalProviders.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import TextArea from "../../components/TextArea.svelte";
	import SaveAndClose from "../../components/SaveAndClose.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";

	// props
	export let pageName = null;
	export let persistUrl = null;
	export let pageTitle = null;
	export let disabled = false;
	export let lastVisitedPage = null;

	let buttons = null;
	let medicalProviderValidator = null;

	// component state updating
	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		errors = [...errors, ...medicalProviderValidator.isValid()];

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError);
				//displayError(response);
			} else {
				registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);
				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};
</script>

<section>
	<Form {disabled} id="form-medical-providers" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Medical Providers</h1>
				<p>
					If you are unable to complete any part of this section of the form, we are here to assist you.
					Please contact us on <ClassActionPhoneNumber /> or via email to <ClassActionEmailAddress />.
				</p>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<div class="confirmation-box-shadow">
			<p>
				<strong>
					Limiting your answer to primary care, gynaecology, and oncology health care providers, please
					identify each doctor or other health care provider who you have seen for medical care and treatment
					from the ten years prior to your cancer diagnosis to present and the approximate dates of
					attendance.
				</strong>
			</p>

			<div class="shadowed-box">
				<MedicalProviders
					{disabled}
					bind:medicalProviders={$model.medicalProviderHistory.medicalProviders}
					bind:medicalProviderValidator
				/>
			</div>

			<FormRow>
				<FormColumn>
					<YesNoGroup
						required
						{disabled}
						name="toldOfTalcLink"
						label="Has any health care provider told you your cancer is related to Johnson &amp; Johnson's Talcum Powder?"
						bind:value={$model.medicalProviderHistory.toldOfTalcLink}
					/>
				</FormColumn>
			</FormRow>

			{#if $model.medicalProviderHistory.toldOfTalcLink === "Yes"}
				<FormRow>
					<FormColumn>
						<TextArea
							label="Please provide details"
							required
							{disabled}
							bind:value={$model.medicalProviderHistory.talcLinkDetails}
							id="talcLinkDetails"
						/>
					</FormColumn>
				</FormRow>
			{/if}

			<FormRow>
				<FormColumn>
					<YesNoGroup
						required
						{disabled}
						name="toldOfOtherLink"
						label="Has any health care provider told you your cancer is related to something other than Johnson &amp; Johnson's Talcum Powder?"
						bind:value={$model.medicalProviderHistory.toldOfOtherLink}
					/>
				</FormColumn>
			</FormRow>

			{#if $model.medicalProviderHistory.toldOfOtherLink === "Yes"}
				<FormRow>
					<FormColumn>
						<TextArea
							label="Please provide details"
							required
							{disabled}
							bind:value={$model.medicalProviderHistory.otherLinkDetails}
							id="otherLinkDetails"
						/>
					</FormColumn>
				</FormRow>
			{/if}
		</div>

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<SaveAndClose>Save and Close</SaveAndClose>
			</FormColumn>
		</FormRow>

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<NavigationButtons bind:buttons nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
			</FormColumn>
		</FormRow>
	</Form>
</section>

<style>
</style>
